module.exports = __webpack_public_path__ + "static/media/foto_stanza_albergo1_comp.18b9d42f.jpg";